import type { Meta, StoryObj } from "@storybook/react";
import noop from "lodash/noop";
import { ScrollView } from "react-native";

import {
  OnboardingStepName,
  OrderedOnboardingSteps,
} from "@/constants/Onboarding";
import type { ActiveOnboardingCardProps } from "@/ui/components/onboarding/v2/cards/ActiveOnboardingCard";
import { ActiveOnboardingCard } from "@/ui/components/onboarding/v2/cards/ActiveOnboardingCard";
import { VStack } from "@/ui/layout";

const StoryMeta: Meta<ActiveOnboardingCardProps> = {
  title: "Components/Onboarding/Cards/Active Onboarding Card",
  component: ActiveOnboardingCard,
  args: {
    onActionPress: noop,
    stepName: OnboardingStepName.Profile,
    testID: "story",
  },
  argTypes: {
    stepName: {
      control: "select",
      options: OrderedOnboardingSteps,
    },
  },
};

type Story = StoryObj<ActiveOnboardingCardProps>;

const Profile: Story = {
  args: { stepName: OnboardingStepName.Profile },
};

const ClinicalPicture: Story = {
  args: { stepName: OnboardingStepName.ClinicalPicture },
};

const Treatment: Story = {
  args: { stepName: OnboardingStepName.Treatment },
};

const CareTeam: Story = {
  args: { stepName: OnboardingStepName.CareTeam },
};

const YourWhy: Story = {
  args: { stepName: OnboardingStepName.YourWhy },
};

const AllSteps: Story = {
  render: (args) => (
    <ScrollView>
      <VStack gap={12} padding={16} width="100%">
        {OrderedOnboardingSteps.map((stepName) => (
          <ActiveOnboardingCard
            {...args}
            key={stepName}
            stepName={stepName}
            testID={stepName}
          />
        ))}
      </VStack>
    </ScrollView>
  ),
};

const AllStepsProxy: Story = {
  args: { patientName: "Renee" },
  render: (args) => (
    <ScrollView>
      <VStack gap={12} padding={16} width="100%">
        {OrderedOnboardingSteps.map((stepName) => (
          <ActiveOnboardingCard
            {...args}
            key={stepName}
            stepName={stepName}
            testID={stepName}
          />
        ))}
      </VStack>
    </ScrollView>
  ),
};

export {
  AllSteps,
  AllStepsProxy,
  CareTeam,
  ClinicalPicture,
  Profile,
  Treatment,
  YourWhy,
};
export default StoryMeta;
